import { steps } from "./consts";

const ImageGrid = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative">
      {steps.map((step) => (
        <div
          key={step.title}
          className="group flex flex-col items-center text-center md:items-start md:text-left 
                     border border-[#411D1938] rounded-[20px] p-5 transition-all duration-300 
                     hover:text-white hover:border-transparent
                     hover:bg-[linear-gradient(270.95deg,#136A85_0%,#00A3D4_87.52%)]
                     w-[90%] max-w-sm mx-auto md:w-full"
        >
          <step.icon className="h-[40px]" />
          <span className="text-[20px] font-bold">{step.title}</span>
          <span className="text-black-600 text-[14px] group-hover:text-white">
            {step.desc}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ImageGrid;
